var list = 'fx_c76f37be_8wa721';
var listRightSlot = 'fx_c76f37be_8wa722';
var listRoot = 'fx_c76f37be_8wa720';

export { list, listRightSlot, listRoot };
//# sourceMappingURL=list.vanilla.mjs.map
